/**
 * Comment system configuration
 *
 * Centralized settings for comment display behavior.
 * Adjust these values to change how comments render.
 */

type CommentConfig = {
  readonly collapseRepliesFromDepth: number
  readonly form: {
    readonly maxLength: number
    readonly rows: {
      readonly reply: { readonly mobile: number; readonly desktop: number }
      readonly root: { readonly mobile: number; readonly desktop: number }
    }
  }
  readonly maxDepth: number
}

export const commentConfig = {
  collapseRepliesFromDepth: 1,
  form: {
    maxLength: 2000,
    rows: {
      reply: { desktop: 3, mobile: 6 },
      root: { desktop: 4, mobile: 6 },
    },
  },
  maxDepth: 2,
} as const satisfies CommentConfig
